/** @format */

import { cssVars } from '@atoms/GlobalStyles';
import styled from 'styled-components';

export const StyledTr = styled.tr`
  border-bottom: 1px solid var(--grey-100);
  cursor: ${(props) => (props.onClick ? 'pointer' : 'default')};

  :hover {
    background-color: ${cssVars.lightBlue};
  }
`;
